import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Secuencia`, method: 'GET', body: null})
}